export type PsychAssistEmphasis = "none" | "improving" | "declining";

export const MEANINGFUL_ER_DELTA = 0.5;

export function resolvePsychAssistEmphasis(
  previousScore: number | null,
  currentScore: number,
): PsychAssistEmphasis {
  if (previousScore === null) return "none";
  const delta = currentScore - previousScore;
  if (Math.abs(delta) < MEANINGFUL_ER_DELTA) return "none";
  return delta > 0 ? "improving" : "declining";
}
